<infos-guidance [guidanceTemplate]="guidance" noSideMargin />
<ng-template #guidance>
  <div class="body-2 text-charcoal">
    The repairer’s new company name will be used for all new jobs moving forward. All pre-existing jobs will continue to
    reflect the current company name, on reports, invoices, etc.
  </div>
</ng-template>
<form [formGroup]="form" (ngSubmit)="saveOrExecuteAction()" class="mt-25">
  <mat-form-field>
    <mat-label>Company Name</mat-label>
    <input formControlName="companyName" matInput />
    @if (companyName.hasError('required')) {
      <mat-error>
        Company Name is <strong>{{ getErrorMessage(companyName.errors) }}</strong>
      </mat-error>
    }
  </mat-form-field>
</form>
